import client from './apolloClient';
import * as Queries from './queries';
import * as Mutations from './mutations';

export { Queries, Mutations };
export default client;
